module.exports = __webpack_public_path__ + "img/android-launchericon-144-144.ffc2c0b8.png";